import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "row mt-2" }
const _hoisted_6 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_7 = { class: "col-sm-8" }
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_10 = { class: "col-sm-8" }
const _hoisted_11 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = { class: "col-sm-8" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "row mt-2" }
const _hoisted_16 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_17 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`traderId`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_TraderMultiselect, {
                  class: _normalizeClass(parentProps.class),
                  disabled: !!_ctx.form.id,
                  multiple: false,
                  small: false,
                  modelValue: _ctx.form.trader,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.trader) = $event))
                }, null, 8, ["class", "disabled", "modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.helper.trans("labels.priority")) + ":", 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn w-100", _ctx.priorityClass(_ctx.form.priority)]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.togglePriority()), ["prevent"]))
            }, _toDisplayString(_ctx.form.priority), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.helper.trans("labels.expire_at")) + ":", 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`expiredAt`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_DatePicker, {
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.expiredAt,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.expiredAt) = $event)),
                  mode: "dateTime",
                  "model-modifiers": {string: true},
                  is24hr: "",
                  masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                }, {
                  default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                    _createElementVNode("input", {
                      class: "form-control",
                      placeholder: _ctx.helper.trans('labels.expire_at'),
                      value: inputValue,
                      onFocus: togglePopover,
                      onChange: inputEvents.change
                    }, null, 40, _hoisted_11)
                  ]),
                  _: 2
                }, 1032, ["class", "modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-sm-4" }, null, -1)),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickPresets, (preset) => {
              return (_openBlock(), _createElementBlock("button", {
                key: preset.id,
                onClick: _withModifiers(($event: any) => (_ctx.applyPreset(preset)), ["prevent"]),
                type: "button",
                class: "btn btn-sm btn-outline-secondary me-2 mb-2"
              }, _toDisplayString(_ctx.presetLabel(preset)), 9, _hoisted_14))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.traffic_group")) + ":", 1),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_TrafficGroupMultiselect, {
              multiple: false,
              modelValue: _ctx.form.trafficGroup,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.trafficGroup) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}